var render = function render() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h

  return _c(
    "div",
    {
      staticClass: "five-stars-input",
      style: {
        width: _vm.width + "px",
      },
    },
    _vm._l(5, function (i) {
      return _c(
        "button",
        {
          key: i,
          on: {
            click: function click($event) {
              return _vm.setValue(i)
            },
          },
        },
        [
          _c("studip-icon", {
            attrs: {
              shape: _vm.getShape(i),
              size: _vm.size,
              alt: _vm.$gettextInterpolate(
                _vm.$ngettext(
                  "auswählen, um mit einem Stern zu bewerten.",
                  "auswählen, um mit %{i} Sternen zu bewerten.",
                  i
                ),
                {
                  i: i,
                }
              ),
            },
          }),
        ],
        1
      )
    }),
    0
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }